import { combineReducers } from "redux";
import {
  PERMOHONAN_DOKUMEN_ADD_ERROR,
  PERMOHONAN_DOKUMEN_ADD_LOADING,
  PERMOHONAN_DOKUMEN_ADD_SUCCESS,
  PERMOHONAN_DOKUMEN_GET_ERROR,
  PERMOHONAN_DOKUMEN_GET_LOADING,
  PERMOHONAN_DOKUMEN_GET_SUCCESS,
  PERMOHONAN_DOKUMEN_VIEW_ERROR,
  PERMOHONAN_DOKUMEN_VIEW_LOADING,
  PERMOHONAN_DOKUMEN_VIEW_SUCCESS,
} from "../actions/constant";
import Switch from "react-bootstrap/esm/Switch";

const permohonanDokumenGetError = (state = false, action) => {
  switch (action.type) {
    case PERMOHONAN_DOKUMEN_GET_ERROR:
      return action.permohonanDokumenGetError;
    default:
      return state;
  }
};
const permohonanDokumenGetLoading = (state = false, action) => {
  switch (action.type) {
    case PERMOHONAN_DOKUMEN_GET_LOADING:
      return action.permohonanDokumenGetLoading;
    default:
      return state;
  }
};
const permohonanDokumenGetSuccess = (state = false, action) => {
  switch (action.type) {
    case PERMOHONAN_DOKUMEN_GET_SUCCESS:
      return action.permohonanDokumenGetSuccess;
    default:
      return state;
  }
};

const perdok = (state = [], action) => {
  switch (action.type) {
    case PERMOHONAN_DOKUMEN_GET_SUCCESS:
      return action.perdok;
    default:
      return state;
  }
};

const permohonanDokumenViewError = (state = false, action) => {
  switch (action.type) {
    case PERMOHONAN_DOKUMEN_VIEW_ERROR:
      return action.permohonanDokumenViewError;
    default:
      return state;
  }
};

const permohonanDokumenViewLoading = (state = false, action) => {
  switch (action.type) {
    case PERMOHONAN_DOKUMEN_VIEW_LOADING:
      return action.permohonanDokumenViewLoading;
    default:
      return state;
  }
};

const permohonanDokumenViewSuccess = (state = false, action) => {
  switch (action.type) {
    case PERMOHONAN_DOKUMEN_VIEW_SUCCESS:
      return action.permohonanDokumenViewSuccess;
    default:
      return state;
  }
};

const perdoks = (state = [], action) => {
  switch (action.type) {
    case PERMOHONAN_DOKUMEN_VIEW_SUCCESS:
      return action.perdoks;
    default:
      return state;
  }
};

const permohonanDokumenAddError = (state = false, action) => {
  switch (action.type) {
    case PERMOHONAN_DOKUMEN_ADD_ERROR:
      return action.permohonanDokumenAddError;
    default:
      return state;
  }
};

const permohonanDokumenAddLoading = (state = false, action) => {
  switch (action.type) {
    case PERMOHONAN_DOKUMEN_ADD_LOADING:
      return action.permohonanDokumenAddLoading;
    default:
      return state;
  }
};

const permohonanDokumenAddSuccess = (state = false, action) => {
  switch (action.type) {
    case PERMOHONAN_DOKUMEN_ADD_SUCCESS:
      return action.permohonanDokumenAddSuccess;
    default:
      return state;
  }
};

const permohonanDokumenReducer = combineReducers({
  permohonanDokumenGetError,
  permohonanDokumenGetLoading,
  permohonanDokumenGetSuccess,
  perdok,

  permohonanDokumenViewError,
  permohonanDokumenViewLoading,
  permohonanDokumenViewSuccess,
  perdoks,

  permohonanDokumenAddError,
  permohonanDokumenAddLoading,
  permohonanDokumenAddSuccess,
});

export default permohonanDokumenReducer;
